import React from 'react';

export default function MarketProblem() {
  return (
    <section className="py-[72px] bg-[#030509]">
      <div className="w-[calc(100%-40px)] md:w-[calc(100%-64px)] max-w-[1200px] mx-auto">
        <div className="max-w-[800px]">
          <h2 className="text-[clamp(34px,3.8vw,54px)] font-semibold text-white leading-[1.08] tracking-[-0.035em] mb-[24px]">
            Marketing decisions become harder when the market keeps moving.
          </h2>
          <p className="text-[clamp(17px,1.3vw,20px)] text-[#A7ADB8] leading-[1.65] font-normal">
            Competitors launch campaigns, change offers and test new messages every day. Without structured intelligence, teams react late, repeat what others are doing or spend without understanding the wider market.
          </p>
        </div>
      </div>
    </section>
  );
}